module.exports = __webpack_public_path__ + "static2023-4-17/img/2020_1022_bg.cf99b4a6.png";